function CtaSection() {
  return (
    <section className="cta-area py-100">
      <div className="container text-center">
        <h2>Start Learning With Kademy Today</h2>
        <p>Upgrade your skills with expert-led courses.</p>
        <a href="/courses" className="theme-btn">
          Explore Courses
        </a>
      </div>
    </section>
  );
}
export default CtaSection;
